export default "__VITE_ASSET__7fb3d40b__"